import { render, staticRenderFns } from "./rockiot.animated.number.vue?vue&type=template&id=5dbcbec8&"
import script from "./rockiot.animated.number.vue?vue&type=script&lang=js&"
export * from "./rockiot.animated.number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports